<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { formatTime } from '@/utils/datetime'

import { Button } from '@/components/ui/button'
import { ShoppingCart } from 'lucide-vue-next'

import PreviewItemShape from './PreviewItemShape.vue'

const emit = defineEmits(['select'])
const props = defineProps({
  userFeature: {
    type: Object,
    required: true
  },
  feature: {
    type: Object,
    required: true
  },
  orgId: {
    type: String,
    required: true
  },
  map: {
    type: Object,
    required: true
  },
  isOrdering: {
    type: Boolean,
    default: false
  }
})

const store = useStore()
const settings = computed(() => store.getters['user/getUserSettings'])
const selected = ref(false)

const protocol = location.protocol === 'https:' ? 'https' : 'http'
const host = `${protocol}://${window.location.host}`
const previewUrl = `${host}/tulum/search/thumb/${props.orgId}/${props.feature.properties.item_type}/${props.feature.id}?token=${props.token}`

const dateFormated = computed(() => {
  return formatTime(props.feature.properties.acquired, settings.value.tz,'D MMMM YYYY')
})

const select = () => {
  selected.value = !selected.value
  emit('select', selected.value)
}
</script>

<template>
  <div class="mb-3 rounded border border-gray-200 space-y-3">
    <div class="flex space-x-3 p-2 m-0">
      <div>
        <PreviewItemShape
          :scene-feature="feature"
          :user-geometry="userFeature.geometry"
          :image-url="previewUrl"
          :map="map"
        />
      </div>
      <div class="flex-1">
        <h2 class="font-bold mb-1">{{  dateFormated }}</h2>
        <div>
          <p class="flex justify-between"><span>Type:</span> {{ feature.properties.item_type }}</p>
          <p class="flex justify-between"><span>Cloud Cover:</span> {{ feature.properties.cloud_cover }}%</p>
          <p class="flex justify-between"><span>Clear Confidence:</span> {{ feature.properties.clear_confidence_percent }}%</p>
          <p class="flex justify-between"><span>Pixel Resolution:</span> {{ feature.properties.pixel_resolution }}m/px</p>
        </div>
      </div>
    </div>
    <div v-if="!isOrdering" class="flex justify-between items-center border-t border-gray-200 p-2">
      <div>
      </div>
      <div class="space-x-2">
        <Button size="sm" class="space-x-1" @click="select">
          <ShoppingCart class="w-4 h-4" />
          <span v-if="!selected">Order</span>
          <span v-else>Unselect</span>
        </Button>
      </div>
    </div>

    <!-- <div class="mb-3">
      <p><span class="font-medium">ID:</span> {{ feature.id }}</p>
      <p><span class="font-medium">Acquired:</span> {{ feature.properties.acquired }}</p>
      <p><span class="font-medium">Published:</span> {{ feature.properties.published }}</p>
      <p><span class="font-medium">Updated:</span> {{ feature.properties.updated }}</p>
      <p><span class="font-medium">Satellite ID:</span> {{ feature.properties.satellite_id }}</p>
    </div> -->
  </div>
</template>
